import PageTitle from '../../components/pages/pageTitle'
import DoctorsList from '../../components/pages/doctorsList'
import Randevu from '../../components/pages/randevu'
import Address from '../../components/pages/address'
const Doctors = () => {
    return (
        <div>
            <PageTitle title='doctors' />
            <DoctorsList />
            <Randevu />
            <Address />
        </div>
    )
}

export default Doctors
